var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCross = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1707",
    "data-name": "Rectangle 1707",
    width: 64,
    height: 64,
    transform: "translate(0.234 0.234)",
    stroke: "#fff",
    strokeWidth: 4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1731",
    "data-name": "Group 1731",
    transform: "translate(-0.234 -0.234)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M37.937,67.374h0A29.437,29.437,0,0,1,8.5,37.937h0a29.437,29.437,0,0,1,58.873,0h0A29.437,29.437,0,0,1,37.937,67.374Z",
    transform: "translate(-5.703 -5.703)",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_454",
    "data-name": "Line 454",
    x2: 21.062,
    y2: 21.062,
    transform: "translate(21.703 21.703)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_455",
    "data-name": "Line 455",
    x1: 21.062,
    y2: 21.062,
    transform: "translate(21.703 21.703)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 4
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cross.c6877e1d.svg";
export { ForwardRef as ReactComponent };